import { render } from "./login-logo.vue?vue&type=template&id=4be02615&scoped=true"
import script from "./login-logo.vue?vue&type=script&lang=js"
export * from "./login-logo.vue?vue&type=script&lang=js"

import "./login-logo.vue?vue&type=style&index=0&id=4be02615&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be02615"]])

export default __exports__